import { gql } from '@apollo/client';

export const NOTIFICATION_SUB = gql`
  subscription newNotification($userId: String!) {
    newNotification(id: $userId) {
      id
      title
      description
      sender
      createdAt
      link
      receiver
      type
      subType
      scope
      status
      data
    }
  }
`;
